import Icons from "assets/Icons/Icons";
import { create } from "zustand";

export const useAppStore = create((set, get) => ({
  // State
  theme: "light",
  sidebarCollapsed: false,
  notifications: [],
  loading: false,
  headerTitle: "Dashboard",
  headerIcon: Icons.IconDashboard,

  // Actions
  setTheme: (theme) => set({ theme }),

  setHeaderTitle: (title) => set({ headerTitle: title }),

  setHeaderIcon: (icon) => set({ headerIcon: icon }),

  toggleSidebar: () =>
    set((state) => ({
      sidebarCollapsed: !state.sidebarCollapsed,
    })),

  setSidebarCollapsed: (collapsed) =>
    set({
      sidebarCollapsed: collapsed,
    }),

  addNotification: (notification) =>
    set((state) => ({
      notifications: [
        ...state.notifications,
        {
          id: Date.now(),
          timestamp: new Date(),
          ...notification,
        },
      ],
    })),

  removeNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),

  clearNotifications: () => set({ notifications: [] }),

  setLoading: (loading) => set({ loading }),

  // Getters
  getNotificationCount: () => get().notifications.length,

  getUnreadNotifications: () => {
    const { notifications } = get();
    return notifications.filter((n) => !n.read);
  },
}));
